<template>
  <v-app>
    <v-main class="mx-10">
      <v-row justify="center" class="mt-16">
        <v-col cols="12" sm="8" md="6">
          <v-card class="pa-6 text-center">
            <v-card-title class="justify-center text-h5">
              Zamówienia i faktury Partnerów B2B zostały przeniesione
            </v-card-title>
            <v-card-text>
              Obsługa zamówień partnerów B2B oraz ich faktur działa teraz w aplikacji Magazyn. Ta strona nie jest już
              używana.
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="primary" href="https://magazyn.masdiag.pl">
                Przejdź do Magazynu
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>
